import { render, staticRenderFns } from "./refund_logistics.vue?vue&type=template&id=4caad6a3&scoped=true"
import script from "./refund_logistics.vue?vue&type=script&lang=js"
export * from "./refund_logistics.vue?vue&type=script&lang=js"
import style0 from "./refund_logistics.vue?vue&type=style&index=0&id=4caad6a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4caad6a3",
  null
  
)

export default component.exports